"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FormSheet = /*#__PURE__*/function () {
  /*
    Utility method to get data out of sheet with nested structure.
     Assumes the `key` passed to method consists of two parts joined by a dot.
    The first part will be passed to the itemGetter method to obtain data object.
    The latter will be used to get the actual property from the object.
  */
  function FormSheet(item, getDefault) {
    _classCallCheck(this, FormSheet);

    this.item = item;
    this.getDefault = getDefault;
  }

  _createClass(FormSheet, [{
    key: "get",
    value: function get(key) {
      var value = _lodash["default"].get(this.item, key);

      return value === null || value === undefined ? this.getDefault(key) : value;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var firstKeyPart = key.split(".")[0];

      if (!this.item[firstKeyPart]) {
        this.item[firstKeyPart] = _lodash["default"].assign({}, this.get(firstKeyPart));
      }

      _lodash["default"].set(this.item, key, value);
    }
  }]);

  return FormSheet;
}();

FormSheet.getNested = function (key, itemGetter) {
  var keySplit = key.indexOf(".");

  if (keySplit === -1) {
    return itemGetter(key);
  }

  var itemPart = key.substr(0, keySplit);
  var secondaryPart = key.substr(keySplit + 1);
  var item = itemGetter(itemPart);

  if (!secondaryPart || secondaryPart.length === 0) {
    return item;
  }

  return _lodash["default"].get(item, secondaryPart);
};

FormSheet.getNestedFrom = function (key, itemMap, _ref) {
  var data = _ref.data;
  var keySplit = key.indexOf(".");

  if (keySplit === -1) {
    return itemMap[key] && itemMap[key](data);
  }

  var itemPart = key.substr(0, keySplit);
  var secondaryPart = key.substr(keySplit + 1);
  var item = itemMap[itemPart] && itemMap[itemPart](data);

  if (!secondaryPart || secondaryPart.length === 0) {
    return item;
  }

  return _lodash["default"].get(item, secondaryPart);
};

var _default = FormSheet;
exports["default"] = _default;